const _ = require('underscore');

/**
 * Clear input error markup
 */
function clear_error_markup () {
  $(this).parent().removeClass('error').find('.error-message').remove();
  $(this).off('keyup input change', clear_error_markup);
}

function handle_correction ($el) {
  $el.on('keyup input change', function (event) {
    if(event.which !== 13 && event.keyCode !== 13) {
      clear_error_markup.apply($(this));
    }
  });
}

/**
 * Show loader
 */
function show_loader () {
  $(this).find('.btn-loader').addClass('loading');
}

/**
 * Hide loader
 */
function hide_loader () {
  $(this).find('.btn-loader').removeClass('loading');
}

/**
 * Handle multiple fields errors
 * @param $form
 * @param response
 */
function handle_errors ($form, response) {
  let $el;

  // Removes precedents errors messages
  $form.find('.error-message').remove();

  // Handle devise format
  if(response.errors){
    response = response.errors;
  }

  // Add error messages
  _.mapObject(response, function(message, name) {
    $el =  $form.find('[name*="' + name + '"]:not([type=hidden])');
    if(_.isArray(message)){
      $el.parent().addClass('error').append('<p class="error-message tooltip help on-right undermin-init">' + message.join('<br>') + '</p>');
      $el.parent().parent().addClass('warning');
    }

    handle_correction($el);
  });
}

/**
 * Handle specific case of global form validation
 * @param $form jQuery form
 * @param response xhr.responseJSON
 */
function handle_global_error ($form, response) {
  // Removes precedents errors messages
  $form.find('.error-message').remove();

  const $inputs = $form.find('input[type=text], input[type=password], input[type=email]');
  $inputs.parent().addClass('error');
  $inputs.last().parent().append('<p class="error-message">' + response.error + '</p>');

  $inputs.on('keyup input change', function (event) {
    if(event.which !== 13 && event.keyCode !== 13) {
      $form.find('input').each(function () {
        clear_error_markup.apply($(this));
      });
    }
  });
}

/**
 * Handle form validation
 * @param $form jQuery form
 * @param on_success on success callback
 * @param on_error on error callback (optional)
 */
function handle ($form, on_success, on_error) {

  // Loaders handlers
  $form.on('ajax:before', show_loader);
  $form.on('ajax:error', hide_loader);
  $form.on('ajax:success', function () {
    if(! $(this).find('.btn-loader-redirect').length){
      hide_loader.apply(this);
    }
  });

  // Callbacks handlers
  $form.on('ajax:success', on_success);

  // Specific error handler
  if(on_error){
    $form.on('ajax:error', on_error);
  }
  // Default error handler
  else {
    $form.on('ajax:error', function (event, xhr) {
      if (xhr.responseJSON.error) handle_global_error($form, xhr.responseJSON);
      else handle_errors($form, xhr.responseJSON);
    });
  }
}

module.exports = {
  handle: handle,
  clear_error_markup: clear_error_markup,
  show_loader: show_loader,
  hide_loader: hide_loader,
  handle_correction: handle_correction
};
